import {Injectable, Pipe, PipeTransform} from "@angular/core";

/**
 * How to use, {{ '04:24:37' | removeLeadingZeros }}
 */
@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'resultsRemoveLeadingZeros'
})
export class RemoveLeadingZerosPipe implements PipeTransform {
  transform(time: string|undefined): string {
    if (!time) {
      return '';
    }
    return time.replace(/^00:/, '').replace(/^0(?!:)/, '');
  }
}
